<template>
  <div class="modal_body register-table">
    <div style="height: 282px">
      <div style="margin: 30px 0 10px 0;">
        {{ $t('modal.plan_upgrade.msg01') }}
      </div>
      <div style="margin: 20px 0;">
        {{ $t('modal.plan_upgrade.msg02') }}
      </div>
    </div>
    <div class="pop_add_btn">
      <a
          @click="handleClick"
          class="btn blue btn_basics pointer no-drag"
      >
        {{ $t('modal.plan_upgrade.btn') }}
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  components: {},
  props: [
  ],
  methods: {
    ...mapGetters(['getLatestPurchaseInfo']),
    handleClick() {
      this.$modal.hide('patient-append-modal');

      if (this.getLatestPurchaseInfo().isSubscribeActive)
        this.$modal.show('change-service-plan-modal-app', this.getLatestPurchaseInfo().paymentInfo)
      else
        this.$router.push('/payments');
    }
  }
}
</script>
<style lang="scss">
.sub_title {
  margin-top: 1rem;
}

.gender_select {
  overflow: hidden;

  li {
    width: 47%;
    float: left;
  }
}

.pop_add_btn {
  flex: 1 1 5rem;
  place-items: flex-end;
}

.register-table {
  .table-container {
    grid-template-columns: 1fr;
  }
}
</style>